import React from "react";
import { Flex, Loader } from "@fluentui/react-northstar";

import Img from "../../../../../../assets/illustrations/employee_folder/contrat_qualif_job.svg";
import Card from "../../../Cards";
import PersonnalInformation from "../../../Cards/CardIdentity/PersonnalInformation";
import CivilStatus from "../../../Cards/CardIdentity/CivilStatus";
import SurroundingPeople from "../../../Cards/CardIdentity/SurroundingPeople";
import IdentityDocuments from "../../../Cards/CardIdentity/IdentityDocuments";
import QualificationAndJob from "../../../Cards/CardContract/QualificationAndJob";
import { useEmployeeFolderIdUser } from "../../../../store";
import { _api_get_contract, _api_get_identity } from "../../../../api";
import { QUERY_KEY } from "../../../../constants";
import { useQuery } from "react-query";
import TimeJobAndSalary from "../../../Cards/CardContract/TimeJobAndSalary";
import DatesContract from "../../../Cards/CardContract/DatesContract";
import ContractAndAvenant from "../../../Cards/CardContract/ContractAndAvenant";
import styled from "styled-components";
import { DEVICE } from "../../../../../../constants/responsive";
import { Section } from "../TabIdentity";

const TabContract = () => {
    const id_employee = useEmployeeFolderIdUser();

    const {
        data: contract_data,
        isLoading: is_loading_contract,
        isFetching: isFetchingContractList,
    } = useQuery(
        [QUERY_KEY + "::contract"],
        () => _api_get_contract(id_employee),
        {
            refetchOnWindowFocus: false,
        }
    );

    if (is_loading_contract) {
        return <Loader content="chargement des informations" />;
    }

    return (
        <FlexContainerContract>
            <Section column>
                {/* qualification & Job */}
                <QualificationAndJob contract_data={contract_data} />
            </Section>
            <Section column>
                {/* Temps de travail & salaire */}
                <TimeJobAndSalary contract_data={contract_data} />
            </Section>
            <Section column>
                {/* BEGIN CONTRACT */}
                <DatesContract contract_data={contract_data} />

                <Card column>
                    {/* documents */}
                    <Card.Body
                        content={
                            <ContractAndAvenant
                                identity_documents={contract_data?.documents}
                                fetchingContractList={isFetchingContractList}
                            />
                        }
                    />
                </Card>
            </Section>
        </FlexContainerContract>
    );
};

export default TabContract;

const FlexContainerContract = styled(Flex)`
    @media ${DEVICE.mobileS} {
        justify-content: center;
        flex-wrap: wrap;
        gap: 32px;
        width: 100%;
        padding-inline: 16px;
    }
    @media ${DEVICE.mobileM} {
    }
    @media ${DEVICE.mobileL} {
    }
    @media ${DEVICE.tablet} {
    }
    @media ${DEVICE.laptop} {
        justify-content: space-between;
        flex-wrap: nowrap;
        width: 100%;
        gap: 8px;
        padding: 4px;
    }
    @media ${DEVICE.laptopL} {
        gap: 32px;
        padding: 0px;
    }
    @media ${DEVICE.desktop} {
    }
`;
